<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.$router.replace({ name: 'register/rate_plan' })
  },
}
</script>
